import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pv-percent-render',
    template: `
    {{renderValue | percent}}
  `,
    standalone: false
})
export class PercentRenderComponent implements OnInit {

  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = this.value?.toString()?.toUpperCase();
  }

}
